<template>
  <div><h1>posts</h1></div>
</template>
